import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import "./styles.css";

const UserInputViewer = ({ text, tag: Tag, className, ...props }) => {
  if (!Tag) {
    throw new Error("Tag needed for UserInputViewer component");
  }
  if (Tag === "Link") {
    return (
      <Link {...props} className={`user-input-viewer ${className || ""}`}>
        {text}
      </Link>
    );
  }

  return (
    <Tag {...props} className={`user-input-viewer ${className || ""}`}>
      {text}
    </Tag>
  );
};

UserInputViewer.propTypes = {
  text: PropTypes.string.isRequired,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    .isRequired,
  className: PropTypes.string,
};

export default UserInputViewer;
